import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// const routes = [
//   {
//     path: '/',
//     name: 'home',
//     component: () => import(/* webpackChunkName: "home" */ '@/views/home')
//   }
// ]

let pages = {
	//'/':()=>import('@/views/shared/test123'),
	"": {
		component: () => import("@/views/shared/layout"),
		children: {
			"/": () => import("@/views/home"),
			"/sitemap": () => import("@/views/home/sitemap"),
			"/alert/news": () => import("@/views/alert/news"),
			"/alert/message": () => import("@/views/alert/message"),
			"/alert/weather": () => import("@/views/alert/weather"),
			"/alert/otherWarn": () => import("@/views/alert/otherWarn"),
			"/alert/warn/:type": () => import("@/views/alert/warn"),
			"/alert/:type": () => import("@/views/alert"),
			"/monitor/weather": () => import("@/views/monitor/weather"),
			"/monitor/rain": () => import("@/views/monitor/rain"),
			"/monitor/water": () => import("@/views/monitor/water"),
			"/monitor/reservoir": () => import("@/views/monitor/reservoir"),
			"/monitor/floodSensor": () => import("@/views/monitor/floodSensor"),
			"/monitor/weather": () => import("@/views/monitor/weather"),
			"/monitor/disasterMap": () => import("@/views/monitor/disasterMap"),
			"/monitor/waterRuler": () => import("@/views/monitor/waterRuler"),
			"/monitor/floodMap": () => import("@/views/monitor/floodMap"),
			"/monitor/cctv": () => import("@/views/monitor/cctv"),
			"/monitor/cctvTable": () => import("@/views/monitor/cctvTable"),
			"/monitor/disasterStatisticsTable": () =>
				import("@/views/monitor/disasterStatisticsTable"),
			"/flood/device": () => import("@/views/flood/device"),
			"/flood/platform": () => import("@/views/flood/platform"),
			"/disaster/volunteer": () => import("@/views/disaster/volunteer"),
			"/disaster/community": () => import("@/views/disaster/community"),
			"/disaster/floodRescue": () => import("@/views/disaster/floodRescue"),
			"/disaster/downloads": () => import("@/views/disaster/downloads"),
			"/service/alertQuery": () => import("@/views/service/alertQuery"),
			"/service/knowledge": () => import("@/views/service/knowledge"),
			"/service/video": () => import("@/views/service/video"),
			"/service/partner": () => import("@/views/service/partner"),
			"/service/tools": () => import("@/views/service/tools"),
			"/service/app": () => import("@/views/service/app"),
			"/service/app/privacy": () => import("@/views/service/appPrivacy"),
			"*": () => import("@/views/home/NotFound.vue"),
			// '/medication-records': {
			//   component: () => import('@/views/medicationRecords/layout'),
			//   children: {
			//     '': () => import('@/views/medicationRecords'),
			//     '/medication-records/westCharts': () => import('@/views/medicationRecords/charts'),
			//   }
			// },
			// '/userGuide': () => import('@/views/userGuide'),
		},
	},
	//'*': () => import('@/views/404')
};

let routes = (function x(a) {
	if (a)
		return Object.keys(a).map((key) => ({
			path: key,
			name: key,
			component: a[key].component ?? a[key],
			children: x(a[key].children),
		}));
})(pages);

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
